import * as React from 'react'

export const ListOrderedIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19.9999 4H3.99993C3.73471 4 3.48036 4.10536 3.29282 4.29289C3.10529 4.48043 2.99993 4.73478 2.99993 5V19C2.99993 19.2652 3.10529 19.5196 3.29282 19.7071C3.48036 19.8946 3.73471 20 3.99993 20H19.9999C20.2651 20 20.5195 19.8946 20.707 19.7071C20.8946 19.5196 20.9999 19.2652 20.9999 19V5C20.9999 4.73478 20.8946 4.48043 20.707 4.29289C20.5195 4.10536 20.2651 4 19.9999 4ZM3.99993 2C3.20428 2 2.44122 2.31607 1.87861 2.87868C1.316 3.44129 0.999931 4.20435 0.999931 5V19C0.999931 19.7957 1.316 20.5587 1.87861 21.1213C2.44122 21.6839 3.20428 22 3.99993 22H19.9999C20.7956 22 21.5586 21.6839 22.1213 21.1213C22.6839 20.5587 22.9999 19.7957 22.9999 19V5C22.9999 4.20435 22.6839 3.44129 22.1213 2.87868C21.5586 2.31607 20.7956 2 19.9999 2H3.99993Z'
        fillRule='evenodd'
        clipRule='evenodd'
        fill='currentColor'
      />
      <path
        d='M7.42237 12.6709
        C7.75574 12.646 8.09034 12.7052 8.39501 12.8428
        C8.69958 12.9805 8.96484 13.1921 9.16648 13.4587
        C9.36814 13.7253 9.49974 14.0383 9.54928 14.3689
        C9.5988 14.6996 9.56444 15.0379 9.44968 15.3519
        C9.3349 15.6659 9.14338 15.9462 8.8924 16.167
        C8.87977 16.1781 8.86676 16.1888 8.85333 16.1989L8.23225 16.6664H9.57142
        C9.9396 16.6664 10.2381 16.9649 10.2381 17.3331
        C10.2381 17.7012 9.9396 17.9997 9.57142 17.9997H6.23814
        C5.95149 17.9997 5.69697 17.8165 5.60599 17.5446
        C5.51509 17.2727 5.6081 16.973 5.83711 16.8005L8.02001 15.1573
        C8.09935 15.0849 8.16084 14.9952 8.19775 14.8943
        C8.23597 14.7896 8.2474 14.6769 8.23095 14.5668
        C8.21446 14.4567 8.17047 14.3522 8.10335 14.2634
        C8.03616 14.1746 7.94766 14.1035 7.84619 14.0577
        C7.7447 14.0118 7.63303 13.9921 7.52198 14.0004
        C7.41083 14.0087 7.3031 14.0447 7.20948 14.1052
        C7.11588 14.1657 7.03877 14.2488 6.98553 14.3467
        C6.93232 14.4446 6.90472 14.5543 6.9048 14.6657
        C6.9051 15.0339 6.60693 15.3327 6.2388 15.3331
        C5.87065 15.3334 5.57185 15.0352 5.57149 14.667
        C5.57121 14.3328 5.65468 14.0037 5.81432 13.71
        C5.97409 13.4163 6.20534 13.1669 6.48619 12.9854
        C6.76699 12.804 7.08899 12.6959 7.42237 12.6709Z
        M7.27328 6.07002
        C7.47989 5.96672 7.72519 5.97793 7.92171 6.09932
        C8.11825 6.22079 8.23811 6.43532 8.23811 6.66638V9.99971H8.90477
        C9.27295 9.99971 9.57142 10.2982 9.57142 10.6664
        C9.57142 11.0346 9.27295 11.333 8.90477 11.333H6.23814
        C5.86996 11.333 5.57149 11.0346 5.57149 10.6664
        C5.57149 10.2982 5.86996 9.99971 6.23814 9.99971H6.9048V7.74515L6.53632 7.9294
        C6.207 8.09406 5.80646 7.96054 5.6418 7.63122
        C5.47714 7.3019 5.61066 6.90135 5.93997 6.73669L7.27328 6.07002Z'
        fill='currentColor'
      />
      <path
        d='M11.1142 7.0934
        C11.3017 6.90586 11.5561 6.8005 11.8213 6.8005H17.8213
        C18.0865 6.8005 18.3409 6.90586 18.5284 7.0934
        C18.7159 7.28093 18.8213 7.53529 18.8213 7.8005
        C18.8213 8.06572 18.7159 8.32008 18.5284 8.50761
        C18.3409 8.69515 18.0865 8.8005 17.8213 8.8005H11.8213
        C11.5561 8.8005 11.3017 8.69515 11.1142 8.50761
        C10.9266 8.32008 10.8213 8.06572 10.8213 7.8005
        C10.8213 7.53529 10.9266 7.28093 11.1142 7.0934Z'
        fill='currentColor'
      />
      <path
        d='M11.1142 11.0934
        C10.9266 11.2809 10.8213 11.5353 10.8213 11.8005
        C10.8213 12.0657 10.9266 12.3201 11.1142 12.5076
        C11.3017 12.6951 11.5561 12.8005 11.8213 12.8005H17.8213
        C18.0865 12.8005 18.3409 12.6951 18.5284 12.5076
        C18.7159 12.3201 18.8213 12.0657 18.8213 11.8005
        C18.8213 11.5353 18.7159 11.2809 18.5284 11.0934
        C18.3409 10.9059 18.0865 10.8005 17.8213 10.8005H11.8213
        C11.5561 10.8005 11.3017 10.9059 11.1142 11.0934Z'
        fill='currentColor'
      />
      <path
        d='M11.1142 15.0934
        C10.9266 15.2809 10.8213 15.5353 10.8213 15.8005
        C10.8213 16.0657 10.9266 16.3201 11.1142 16.5076
        C11.3017 16.6952 11.5561 16.8005 11.8213 16.8005H17.8213
        C18.0865 16.8005 18.3409 16.6952 18.5284 16.5076
        C18.7159 16.3201 18.8213 16.0657 18.8213 15.8005
        C18.8213 15.5353 18.7159 15.2809 18.5284 15.0934
        C18.3409 14.9059 18.0865 14.8005 17.8213 14.8005H11.8213
        C11.5561 14.8005 11.3017 14.9059 11.1142 15.0934Z'
        fill='currentColor'
      />
    </svg>
  )
})

ListOrderedIcon.displayName = 'ListOrderedIcon'
